import { submitWork } from './messageContants';

export default (client, options) => {
  client.send(submitWork.replace("<worker.name>", options.worker).replace("<jobID>", options.job_id).replace("<ExtraNonce2>", options.extranonce2).replace("<ntime>", options.ntime).replace("<nonce>", options.nonce));
};
